import { createVanIconComponent } from "./van"

const ArrowRight = createVanIconComponent("arrow")
export default ArrowRight
